export default __webpack_public_path__ + "static/media/bronze-wheel-icon.eb385682.png";